export default {"src":"/_next/static/media/kint-reversed.aa881414.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};